import React, { Component } from 'react';
import { Route, HashRouter } from 'react-router-dom';
import Header from './components/header/Header';
import LoginCard from './components/logincard/LoginCard';
import Home from './components/home/Home';
import Customers from './components/customerslist/CustomersList';
import Items from './components/itemlist/ItemsList';
import Collections from './components/collections/Collections'
import ItemDetailsList from './components/itemdetailslist/ItemDetailsList';
import ScrollToTop from './components/ScrollToTop.js';
import './App.css';
import history from './history';

import _ from 'lodash';

import { Provider } from 'react-redux';
import { store } from './store';

if (window.devToolsExtension) {
  window.devToolsExtension.open();
}

class App extends Component {
  componentDidMount() {
    let id = store.getState().userIDProp;
    if (_.isEmpty(id)) {
      id = window.sessionStorage.getItem('userID');
    }
    if (_.isEmpty(id)) {
      return history.push('/login');
    } else if (history.location.pathname === '/') {
      return history.push('/home');
    }
  };

  scrollToTop = () => {
    window.scrollTo(0, 0);
    return null;
  };

  render() {
    function noop() {}
    if (process.env.APP_ENV !== "development") {
      console.log = noop;
    }
    return (
      <Provider store={store}>
        <HashRouter path="/home" history={history}>
          <div>
            <ScrollToTop />
            <Header history={history} logout={() => store.dispatch({type: '/APP/INITIALISE_STATE'})} />
            <Route path="/login" component={LoginCard} />
            <Route path="/home"  component={Home} />
            <Route path="/customers"  component={Customers} />
            <Route path="/items"  component={Items} />
            <Route path="/collections"  component={Collections} />
            <Route path="/details"  component={ItemDetailsList} />
          </div>
        </HashRouter>
      </Provider>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js